import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiUsers } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const LawyerMatching = () => {
    const { t } = useTranslation();
    const description = t("service_pages.lawyer_matching.description");
    const features = t("service_pages.lawyer_matching.features", { returnObjects: true });
    const highlights = t("service_pages.lawyer_matching.highlights", { returnObjects: true });
    const steps = t("service_pages.lawyer_matching.steps", { returnObjects: true });
    const faqs = t("service_pages.lawyer_matching.faqs", { returnObjects: true });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Lawyer Matching Service",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub Immigration Services",
            telephone: "+1 3108802133",
            email: "info@citznhub.com",
        },
        areaServed: [
            "United States",
            "California",
            "New York",
            "Texas",
            "Florida",
        ],
    };

    // Create a simple icon-based image placeholder
    const IconPlaceholder = () => (
        <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl shadow-lg flex items-center justify-center">
            <FiUsers className="w-48 h-48 text-white opacity-80" />
        </div>
    );

    return (
        <ServiceDetailLayout
            title={t("service_pages.lawyer_matching.title")}
            subtitle={t("service_pages.lawyer_matching.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={null}
            imageAlt="Immigration lawyer matching"
            canonicalUrl="https://citizenhubimmigration.com/services/lawyer-matching"
            structuredData={structuredData}
            customImage={<IconPlaceholder />}
        />
    );
};

export default LawyerMatching;
